import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e77f7554"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "atwork-artist"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(`${_ctx.title}`) + " ", 1),
    _hoisted_1,
    (_ctx.objectTemplate !== 'ART')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.yearObject), 1))
      : _createCommentVNode("", true),
    (_ctx.objectTemplate === 'ART')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.formattedArtists, (artist, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            class: "atwork-artist"
          }, _toDisplayString(`${artist}  ${_ctx.creatorsDates(index)}`), 1))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}